<template>
  <div style="margin-top: 10px">
    <el-form :model="formData" label-width="150px" :rules="rules">
      <el-form-item label="设备类型：" prop="star">
        <el-select v-model="formData.device_id" @change="getMaintenancePositionAll"  placeholder="设备类型" clearable style="width: 215px">
          <el-option v-for="dict in eqDeviceTypeAll" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
        </el-select>

        <div style="margin-left: 100px">
          <span>保养部位：&nbsp;&nbsp;&nbsp;共&nbsp;<span style="color:#0486fe;">{{formData.num}}</span>&nbsp;项</span>
        </div>
        <el-icon @click="addOnePosition()" color="#0486fe" size="25" style="cursor: pointer"><ElIconCirclePlusFilled/></el-icon>
      </el-form-item>


      <div>
        <el-row style="border: 1px solid #4b8de4;padding: 10px;border-radius: 10px;margin-top: 5px" v-for="(item,index) in formData.maintenancePositionList" :key="index">
<!--          <el-col>-->
<!--            <el-icon @click="removeOnePosition(item.nanoid)" color="red" size="25" style="cursor: pointer"><ElIconRemove/></el-icon>-->
<!--            <el-form-item label="部位编号：">-->
<!--              <el-input disabled v-model="item.position_no" style="width: 215px"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col>
            <el-icon @click="removeOnePosition(item.nanoid)" color="red" size="25" style="cursor: pointer"><ElIconRemove/></el-icon>
            <span style="color:blue;font-size: 20px;margin-left: 30px">{{index+1}}</span>
          </el-col>
          <el-col :span="11">
            <el-form-item label="部位名称：" prop="star">
              <el-input v-model="item.position_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="计划工时(分)：" prop="star">
              <el-input v-model="item.plan_hours"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="保养巡检内容：" prop="star">
              <el-input v-model="item.content" ></el-input>
            </el-form-item>
          </el-col>


          <el-row class="box" style="margin-bottom: 10px">
            <el-icon @click="addOneStandardDescribe(item.nanoid)" color="#0486fe" size="25" style="cursor: pointer;margin-left: -40px;margin-top: 5px" ><ElIconCirclePlusFilled /></el-icon>
            <el-col  :span="2" style="margin-left: 10px">编号</el-col>
            <el-col  :span="8">保养标准方法</el-col>
            <el-col  :span="12">报告项</el-col>
          </el-row>

          <el-row v-for="(standardItem,index) in item.standardList" :key="index" class="row">
            <el-col :span="2">
              <spna>{{index+1}}</spna>
            </el-col>

            <el-col :span="8">
              <el-input v-model="standardItem.maintenance_method"  placeholder="保养标准方法"></el-input>
            </el-col>

            <el-col :span="14">
              <el-checkbox name="time_consuming" value=true v-model="standardItem.time_consuming" disabled  label="耗时（分）" />
              <el-radio-group v-model="standardItem.pm_type">
                <el-radio value="replace_part" label="replace_part">更换部品</el-radio>
                <el-radio value="oil_usage" label="oil_usage">油品用量</el-radio>
              </el-radio-group>
            </el-col>

            <div class="close" @click="removeOneStandardDescribe(item.nanoid,standardItem.nanoid)">
              <el-icon color="red" size="25"><ElIconRemove/></el-icon>
            </div>
          </el-row>
        </el-row>
      </div>

      <div style="margin-top: 20px;text-align: center">
        <el-button color="#0486fe" style="width: 100px" @click="updateMaintenancePosition" :loading="loading">提交</el-button>
      </div>

      <div style="height: 40px">
      </div>
    </el-form>

  </div>
</template>

<script>
import {nanoid} from 'nanoid'

export default {
  name: "EqMaintenancePositionZhiZaoEdit",
  inject:['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      formData: {
        device_id: '',
        num:'1',
        maintenancePositionList: [
          {
            nanoid: nanoid(),
            standardList: [
              {
                nanoid: nanoid(),
                time_consuming: true
              }
            ]
          }
        ],
      },
      eqDeviceTypeAll: [],
      rules: {
        star: [{required: true, message: '', trigger: 'red'}],
      },
    }
  },
  computed: {

  },
  methods:{
    addOnePosition() {
      this.formData.maintenancePositionList.push({
        nanoid: nanoid(),
        standardList: [
          {
            nanoid: nanoid(),
            time_consuming: true
          }
        ]
      })
      this.formData.num = this.formData.maintenancePositionList.length
    },
    removeOnePosition(nanoid) {
      let index = this.formData.maintenancePositionList.findIndex(item => item.nanoid === nanoid);
      this.formData.maintenancePositionList.splice(index, 1);
      this.formData.num = this.formData.maintenancePositionList.length
    },
    addOneStandardDescribe(nanoid1) {
      let idx = this.formData.maintenancePositionList.findIndex(item => item.nanoid === nanoid1);
      this.formData.maintenancePositionList[idx].standardList.push({
        nanoid: nanoid(),
        time_consuming: true
      })
    },
    removeOneStandardDescribe(nanoid1,nanoid2) {
      let idx = this.formData.maintenancePositionList.findIndex(item => item.nanoid === nanoid1);
      let index = this.formData.maintenancePositionList[idx].standardList.findIndex(item => item.nanoid === nanoid2);
      this.formData.maintenancePositionList[idx].standardList.splice(index, 1);
    },
    async getEqDeviceTypeAll() {
      await this.$http('eqDsZhiZaoService.getEqDeviceTypeAll',{}, false).then(data => {
        this.eqDeviceTypeAll = data
      }, errMsg => {
        return this.$message.error(errMsg);
      })
    },
    getMaintenancePositionAll() {
      if (!this.formData.device_id) {
        return this.$message.error('设备类型不能为空!')
      }
      this.$http('eqMaintenancePositionZhiZaoService.getMaintenancePositionAll',this.formData).then(data => {
        this.formData.maintenancePositionList = data;
        this.formData.num = this.formData.maintenancePositionList.length
      }, errMsg => {
        return this.$message.error(`页面数据加载失败`+errMsg);
      })
    },
    updateMaintenancePosition(){
      this.loading = true;
      if (!this.formData.device_id) {
        return this.$message.error('设备类型不能为空!')
      }
      let cnt = 0;
      for (let i = 0; i < this.formData.maintenancePositionList.length; i++) {
        let obj = this.formData.maintenancePositionList[i]
        if (!obj.position_name){
          this.loading = false
          return this.$message.error(`第${i + 1}行部位名称不能为空`);
        }
        if (!obj.content){
          this.loading = false
          return this.$message.error(`第${i + 1}行保养内容不能为空`);
        }
        if (!obj.plan_hours){
          this.loading = false
          return this.$message.error(`第${i + 1}行保养计划工时不能为空`);
        }
        cnt++
        for (let j = 0; j < obj.standardList.length; j++) {
          let obj2 = obj.standardList[j]
          if (obj2.time_consuming) {
            if (!obj2.maintenance_method) {
              this.loading = false
              return this.$message.error(`第${i + 1}行部位第${j + 1}行保养标准方法不能为空`);
            }
          }
        }
      }
      if (cnt == 0) {
        this.loading = false
        return this.$message.error("部位数据不能为空");
      }
      this.loading = true;
      this.$http('eqMaintenancePositionZhiZaoService.addMaintenancePosition',this.formData).then(data => {
        this.loading = false;
        this.$fn.closeWindow();
        this.$fn.search();
        return this.$message.success('编辑成功!');
      }, errMsg => {
        this.loading = false;
        return this.$message.error(`页面数据加载失败`+errMsg);
      })
    }

  },created() {
    this.formData.device_id = this.parentData.device_id
    this.getEqDeviceTypeAll()
    this.getMaintenancePositionAll()

  }
}
</script>

<style scoped>
.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
  width: 650px;
  margin-left: 80px
}
.close {
  position: absolute;
  top: 5px;
  margin-left: -40px;
  font-size: 18px;
  cursor: pointer;
}
.row {
  margin-left: 80px;
  width: 650px;
  margin-top: 10px;
  height: 35px;
  line-height: 35px;
  text-align: center;
}
</style>